import { cloneDeep } from 'lodash';

import { SerializableObject } from '../../../legacy/objects/generic/serialization/serializable-object';
import { SessionURL } from '../../core/session-url/session-url';

import { DomMutationSelectionSchema } from './dom-mutation-selection-schema';

export class DomMutationSelection extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected url!: SessionURL;
  protected domMutationId!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Get Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): DomMutationSelectionSchema {
    return new DomMutationSelectionSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(DomMutationSelection.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): DomMutationSelection {
    return new DomMutationSelection(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getUrl(): SessionURL {
    return cloneDeep(this.url);
  }

  public getDomMutationId(): string {
    return this.domMutationId;
  }
}
